import { render, staticRenderFns } from "./ImageNewsTwo.vue?vue&type=template&id=2df6d96c&scoped=true"
import script from "./ImageNewsTwo.vue?vue&type=script&lang=js"
export * from "./ImageNewsTwo.vue?vue&type=script&lang=js"
import style0 from "./ImageNewsTwo.vue?vue&type=style&index=0&id=2df6d96c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2df6d96c",
  null
  
)

export default component.exports